import { render, staticRenderFns } from "./AddQuestionActionBar.vue?vue&type=template&id=33a27206&scoped=true&"
import script from "./AddQuestionActionBar.vue?vue&type=script&lang=js&"
export * from "./AddQuestionActionBar.vue?vue&type=script&lang=js&"
import style0 from "./AddQuestionActionBar.vue?vue&type=style&index=0&id=33a27206&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a27206",
  null
  
)

export default component.exports